import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateUtil } from '../utils/navigate.util';
import { CommonEnums } from '../common.enums';
import { ObjectWrapper } from '../wrappers/object.wrapper';

/**
 * @description
 * RouterService will be used to navigate to different pages.
 * It is wrapper for Router class
 */
@Injectable({
    providedIn: 'root'
})
export class RouterService {

    navigateUtil: NavigateUtil;
    constructor(private router: Router) {
        this.navigateUtil = NavigateUtil.getInstance();
    }

    getSchedulerBaseUrl() {
        return window.location.origin + '/scheduler/#/'
    }

    getSchCmdTaskBaseUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/tasks/edit/ct/' + obj_Id;
    }
    getSchFileWatcherBaseUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/tasks/edit/fw/' + obj_Id;
    }
    getSchBaseCalenderUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/calendars/edit/' + obj_Id;
    }
    getSchEmailBaseUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/email/edit/' + obj_Id;
    }
    getSchFileEventBaseUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/fileevents/edit/' + obj_Id;
    }
    getSchTaskEventUrl(fldr_Id: number, obj_Id: number) {
        return this.getSchedulerBaseUrl() + 'prj/' + fldr_Id + '/schtaskevent/edit/' + obj_Id;
    }
    //*** ADMIN */
    getAdminBaseUrl() {
        return window.location.origin + '/admin/#/'
    }
    getSERVER_LICUrl(): string {
        return this.getAdminBaseUrl() + 'admin/' + -1 + '/serverlic';
    }
    /**
     * goToPage() method will navigate to `objectWrapper.url`.
     */
    goToPage(objectWrapper: ObjectWrapper): void {
        this.router.navigateByUrl(objectWrapper.url);
    }

    goToPageUrl(url: string): void {
        this.router.navigateByUrl(url);
    }

    /**
     *  goToLoginPage() method will use the `/session/login` for routing.
     */
    goToLoginPage(): void {
        this.router.navigateByUrl(this.navigateUtil.getLoginPageUrl());
    }

    /**
     * goToDashboardPage() will navigate to Dash Board Page.
     * path:`/prj/260320/N/dashboard` for routing.
     */
    goToDashboardPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getDashboardUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
     * goToRepConnListPage() will navigate to DataPoint List Page.
     * path:`/prj/260320/N/conn/list` for routing.
     */
    goToRepConnListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getRepConnListUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
     * goToDataObjectListPage() will navigate to DataObject List Page.
     * path:`/prj/260320/N/dobj/list` for routing.
     */
    goToDataObjectListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getDataObjectListUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
     *goToDesignListPage() will navigate to Design List Page.
     * path:`/prj/260320/N/dxmp/dataflow/list` for routing.
     */
    goToDesignListPage(fldr_Id: number, fldr_ReusableFlag: string, reusableFlag: string, streamingFlg: string): void {
        this.router.navigateByUrl(this.navigateUtil.getDesignListUrl(fldr_Id, fldr_ReusableFlag, reusableFlag, streamingFlg));
    }

    /**
     * goToDesignEditPage() will navigate to Design Edit Page.
     * path:`/prj/260320/N/dxmp/dataflow/edit/1883091` for routing.
     */
    goToDesignEditPage(fldr_Id: number, fldr_ReusableFlag: string, dxMp_Id: number, reusableFlag: string, streamingFlg: string): void {
        this.router.navigateByUrl(this.navigateUtil.getDesignEditUrl(fldr_Id, fldr_ReusableFlag, dxMp_Id, reusableFlag, streamingFlg));
    }

    /**
     * goToDMWizardPage() method will navigate to Data Movement Wizard.
     * Path: `/prj/260320/N/dxmp/dataflow/dmw/1883091`
     */
    goToDMWizardPage(dxMp_Id: number): void {
        this.router.navigateByUrl(this.navigateUtil.getDMWizardUrl(dxMp_Id));
    }

    /**
     * goToDataFlowListPage() will navigate to Data Flow List Page.
     * path:`/prj/260320/N/dxmp/dataflow/list` for routing.
     */
    goToDataFlowListPage(fldr_Id: number, fldr_ReusableFlag: string): void {
        this.router.navigateByUrl(this.navigateUtil.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.reusableFlag.NO, CommonEnums.streamingFlg.NO));
    }

    /**
     * goToDataConnectListPage() will navigate to Data Connect List Page.
     * path:`/prj/260320/N/dxmp/dataconnect/list` for routing.
     */
    goToDataConnectListPage(fldr_Id: number, fldr_ReusableFlag: string): void {
        this.router.navigateByUrl(this.navigateUtil.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.reusableFlag.NO, CommonEnums.streamingFlg.DATACONNECT));
    }

    /**
     * goToDataStreamListPage() will navigate to Data Stream List Page.
     * path:`/#/prj/260320/N/dxmp/datastream/list` for routing.
     */
    goToDataStreamListPage(fldr_Id: number, fldr_ReusableFlag: string): void {
        this.router.navigateByUrl(this.navigateUtil.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.reusableFlag.NO, CommonEnums.streamingFlg.YES));
    }

    /**
     * goToStreamListPage() will navigate to Job Flow List Page.
     * path:`/prj/260320/N/dxflow/list` for routing.
     */
    goToStreamListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getStreamListUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
    * goToDBSeqListPage() will navigate to Sequence List Page.
    * path:`/prj/260320/N/nseq/list` for routing.
    */
    goToDBSeqListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getDBSeqListUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
     * goToDBFunListPage() will navigate to Expression List Page.
     * path:`/prj/260320/N/dbfn/list` for routing.
     */
    goToDBFunListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getDBFunListUrl(fldr_Id, fldr_ReusableFlag));
    }

    /**
     * goToUDFListPage() will navigate to UDF List Page.
     * path:`/prj/260320/N/udf/list` for routing.
     */
    goToUDFListPage(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): void {
        this.router.navigateByUrl(this.navigateUtil.getUDFListUrl(fldr_Id, fldr_ReusableFlag));
    }
}